import {SlotsPlaceholder} from '@wix/widget-plugins-ooi';
import classNames from 'classnames';
import React, {type FC} from 'react';
import {CategoryTree} from '../../../category/components/CategoryTree/CategoryTree';
import {useSidePanel} from '../../../category/hooks/useSidePanel';
import {ConditionalRender} from '../../../common/components/ConditionalRender/ConditionalRender';
import {Experiments, GallerySlotIds} from '../../../constants';
import {useGlobals, withGlobals} from '../../../globalPropsContext';
import s from './Filters.scss';
import {FiltersFooter} from './FiltersFooter/FiltersFooter';
import {FiltersHeader} from './FiltersHeader/FiltersHeader';
import {FiltersList} from './FiltersList/FiltersList';

export interface FiltersProps {
  clearFilters: Function;
  shouldShowClearFiltersButton: boolean;
  modalHeaderId?: string;
  combineFiltersAndSort?: boolean;
}

const FiltersComp: FC<FiltersProps> = ({
  shouldShowClearFiltersButton,
  modalHeaderId,
  combineFiltersAndSort,
  clearFilters,
}) => {
  const {
    experiments: {shouldRenderSlotsInGallery},
    shouldShowMobile,
    isCategoryPage,
    usingExtendedGridGalleryStyles,
    slots,
    useExperiments,
  } = useGlobals();

  const {hasCategoriesContent, hasFiltersContent} = useSidePanel();
  const shouldRenderCategoryTree = hasCategoriesContent;
  const shouldRenderFilters = hasFiltersContent || shouldShowMobile || !isCategoryPage;
  const shouldUseMobileFiltersPanelBackground =
    shouldShowMobile && useExperiments.enabled(Experiments.MobileGalleryFiltersDesignSettings);

  const isPluginInstalledInGalleryFiltersTopSlot = !!slots?.[GallerySlotIds.GalleryFiltersTop];
  const isPluginInstalledInGalleryFiltersBottomSlot = !!slots?.[GallerySlotIds.GalleryFiltersBottom];

  return (
    <section
      className={classNames(s.filters, s.dynamicPadding, {
        [s.usingExtendedGridGalleryStyles]: usingExtendedGridGalleryStyles,
        [s.mobileFiltersPanelBackground]: shouldUseMobileFiltersPanelBackground,
      })}>
      {shouldRenderCategoryTree && (
        <ConditionalRender by="gallery_showCategories">
          <CategoryTree />
        </ConditionalRender>
      )}
      {shouldRenderSlotsInGallery && (
        <div className={classNames({[s.galleryFiltersTopSlot]: isPluginInstalledInGalleryFiltersTopSlot})}>
          <SlotsPlaceholder slotId={GallerySlotIds.GalleryFiltersTop} />
        </div>
      )}
      {shouldRenderFilters && (
        <>
          <FiltersHeader
            modalHeaderId={modalHeaderId}
            combineFiltersAndSort={combineFiltersAndSort}
            data-hook={'side-filter-header'}
          />
          <FiltersList combineFiltersAndSort={combineFiltersAndSort} />
          <FiltersFooter clearFilters={clearFilters} shouldShowClearFiltersButton={shouldShowClearFiltersButton} />
        </>
      )}
      {shouldRenderSlotsInGallery && (
        <div className={classNames({[s.galleryFiltersBottomSlot]: isPluginInstalledInGalleryFiltersBottomSlot})}>
          <SlotsPlaceholder slotId={GallerySlotIds.GalleryFiltersBottom} />
        </div>
      )}
    </section>
  );
};

export const Filters = withGlobals(FiltersComp);
